import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const keyboardHintRecipeFn = /* @__PURE__ */ createRecipe('keyboard-hint', {}, [])

const keyboardHintRecipeVariantMap = {}

const keyboardHintRecipeVariantKeys = Object.keys(keyboardHintRecipeVariantMap)

export const keyboardHintRecipe = /* @__PURE__ */ Object.assign(memo(keyboardHintRecipeFn.recipeFn), {
  __recipe__: true,
  __name__: 'keyboardHintRecipe',
  __getCompoundVariantCss__: keyboardHintRecipeFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: keyboardHintRecipeVariantKeys,
  variantMap: keyboardHintRecipeVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, keyboardHintRecipeVariantKeys)
  },
  getVariantProps: keyboardHintRecipeFn.getVariantProps,
})